import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Offer, Reward } from "@obg/ngx.common";

@Component({
	selector: "obg-m-deposit-bonuses",
	templateUrl: "./deposit-bonuses.component.html",
	styleUrls: ["./deposit-bonuses.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositBonusesComponent {
	@HostBinding("class.obg-m-deposit-bonuses") hostCssClass = true;

	@Input() items: (Offer | Reward)[] | undefined;

	@Output() getBonus = new EventEmitter<Offer | Reward>();

	@Output() depositWithoutBonus = new EventEmitter<void>();

	@Output() itemSelected = new EventEmitter<Offer | Reward>();

	trackByBonus(_index: number, bonus: Offer | Reward) {
		return "id" in bonus ? bonus.id : bonus.identifier;
	}
}
